import styled from "styled-components";
import { AppliancesTableStyle } from "../appliancesTable/appliancesTableStyle";

export const ApplianceListTableStyle = styled(AppliancesTableStyle)`
    .bar {
        justify-content: flex-end;
        margin-bottom: 15px;
    }
`;
